import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ClearQueueButton from "../Components/OtherButtons/ClearQueueButton";
import FullScreenButton from "../Components/OtherButtons/FullScreenButton";
import AddSongToFav from "pages/musicPage/shared/AddSongToFav";
import VolumeButton from "../Components/OtherButtons/VolumeButton";
import VisibleQueueButton from "../Components/OtherButtons/VisibleQueueButton";
import AddRadioToFavPlayer from "pages/radioPage/RadioPlayer/AddRadioToFavPlayer";

// frosted glass icon button (matches ControlButtons)
const glassBtn =
  "flex h-9 w-9 items-center justify-center rounded-full border border-white/10 bg-white/5 text-white/70 backdrop-blur-md transition-colors hover:bg-white/15 hover:text-white";

function OtherButtons({
  audioRef,
  showQueue,
  visibleQueue,
  isMuted,
  setIsMuted,
  toggleMute,
  fullScreen,
  setFullScreen,
  currentAudio,
  playlist,
  music,
  radio,
  podcast,
}: any) {
  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);
  const userFavorites = useSelector((state: any) => state?.user?.userFavorites);
  const [favSongs, setFavSongs] = useState<any>();

  useEffect(() => {
    if (loggedInUser) {
      const favoriteMusicIds = userFavorites?.favourite_music?.map(
        (item: any) => item.id
      );
      setFavSongs(favoriteMusicIds);
    }
  }, [currentAudio, loggedInUser]);

  const handleFullScreen = () => {
    setFullScreen(!fullScreen);
  };

  return (
    <div className="flex items-center justify-end gap-2 text-xl max-md:hidden">
      {/* clear queue */}
      <span className={glassBtn}>
        <ClearQueueButton spinSize={20} />
      </span>

      {/* full screen */}
      {!radio && (
        <span className={glassBtn}>
          <FullScreenButton handleFullScreen={handleFullScreen} />
        </span>
      )}

      {/* favorite */}
      {music && (
        <span className={glassBtn}>
          <AddSongToFav song={currentAudio} favorite={favSongs} />
        </span>
      )}
      {radio && (
        <span className={glassBtn}>
          <AddRadioToFavPlayer station={currentAudio} Icon={true} />
        </span>
      )}

      {/* volume */}
      <span className={`${glassBtn} group relative`}>
        <VolumeButton
          isMuted={isMuted}
          toggleMute={toggleMute}
          audioRef={audioRef}
          setIsMuted={setIsMuted}
        />
      </span>

      {!radio && playlist?.length > 1 && (
        <span className={`${glassBtn} ${visibleQueue ? "bg-white/15 text-white" : ""}`}>
          {/* visible queue */}
          <VisibleQueueButton
            visibleQueue={visibleQueue}
            executeFunction={showQueue}
          />
        </span>
      )}
    </div>
  );
}

export default OtherButtons;